import { CreateElement } from '@src/vue'
import { Component } from 'vue-property-decorator'

import { ListCell } from '@src/components/table-list/cells'
import { H6, Subtitle2 } from '@src/elements/typography/typography'
import Member, { MemberState } from '@src/data/member'
import { Icon } from '@src/elements/icon/icon'
import { Tooltip } from '@src/elements/tooltip/tooltip'

@Component({
  computed: {
    filter () {
      return this.$store.state.memberFilters.name || ''
    }
  }
})
export class NameCell extends ListCell {
  item: Member
  filter: string

  viewMemberStatus () {
    this.$router.push({ path: '/trainers/platform/members/' + this.item.id + '/status' })
  }

  render (h: CreateElement) {
    function highlightSearch (haystack: string, needle: string) {
      const idx = haystack.toLowerCase().indexOf(needle)
      if (idx !== -1) {
        return <span>
          {haystack.substring(0, idx)}
          <span class='highlight'>{haystack.substring(idx, idx + needle.length)}</span>
          {haystack.substring(idx + needle.length)}
        </span>
      } else {
        return haystack
      }
    }

    const needle = this.filter.toLowerCase()
    const isDisabled = this.item.state === MemberState.DEACTIVATED
    const hasFullName = this.item.fullName.trim() !== ''

    return <div onClick={this.viewMemberStatus} class={`cell name-cell ${isDisabled ? 'disabled' : ''}`}>
      <H6><span>{highlightSearch(hasFullName ? this.item.fullName : this.item.username ? this.item.username : this.item.displayName, needle)}</span></H6>
      <Subtitle2>
        {isDisabled ? <Tooltip content={this.$t('PAGE.MEMBERS.FILTER.STATE.DEACTIVATED_USER')}><Icon name='brand/deactivated-member' /></Tooltip> : null}
        {highlightSearch(hasFullName && this.item.username ? this.item.username : this.item.displayName ? this.item.displayName : '', needle)}
      </Subtitle2>
    </div>
  }
}
